export default {
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        columnGap: "12px",
        alignItems: "flex-start",
        padding: "0 60px 40px 40px",
        height: "100%",
    },

    popupModal: {
        overflowY: "visible !important"
    },

    selectForms: {
        width: "95%",
        marginTop: "20px"
    },

    footer: {
        display: "flex",
        justifyContent: "start",
        margin: "20px"
    },

    buttons: {
        margin: "0 0 0 20px",
        width: "140px",
        height: "40px",
    },
}